document.addEventListener('DOMContentLoaded', function () {
    const CSRF_TOKEN_EXPIRE_TIME = 15 * 60 * 1000

    setTimeout(function () {
        location.reload()
    }, CSRF_TOKEN_EXPIRE_TIME)
})
